import { Spacer } from "shared/layout";
import { colors, space } from "shared/styles/constants";
import styled from "styled-components";

export const StyledGuestlistForm = styled.div`
  @media print {
    display: none;
  }
`;

export const StyledGuestTableWrapper = styled(Spacer)`
  @media print {
    background-color: transparent;
    margin-bottom: ${space.xl};
    margin-top: 0 !important;
    * {
      background-color: transparent;
    }
  }
`;

export const StyledGuestListTicketAndPassesWrapper = styled(Spacer)`
  @media print {
    background-color: ${colors.grey6};
    page-break-inside: avoid;
    padding: ${space.s};
    * {
      background-color: ${colors.grey6};
      border-radius: 0;
      padding-left: ${space.xxs};
    }
  }
`;
